import { useEffect } from "react";
import { captureAttribution } from "../utils/leadCapture";
import { initPixel } from "../utils/tracking";

/** Captures UTM/fbclid and loads the Meta Pixel once on app mount. */
export function useTrackingInit(): void {
  useEffect(() => {
    captureAttribution();
    initPixel();
  }, []);
}
